import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../../../store';
import { Calendar, saveCalendarSelected } from '../../../../../features/calendar/calendar-slice';
import { useEffect } from 'react';
import { AddressContent, AddressIcon, AddressIconBox, AddressRadio, AddressRoot, AddressTitle } from './style';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface Props {
  physicalAppointments: Calendar[];
  availability: Record<string, boolean>;
}

const Addresses = ({ physicalAppointments, availability }: Props) => {
  const dispatch = useDispatch();
  const { userId: doctorId } = useParams();
  const {
    calendar: { calendarSelected, calendarsAvailables }
  } = useSelector((state: RootState) => state);

  useEffect(() => {
    const calendarWithAvailability = Object.keys(availability).filter(keyId => availability[keyId] === true);
    if (calendarWithAvailability.length == 1) {
      const calendarId = calendarWithAvailability[0];
      const calendar = calendarsAvailables.find(item => item.id === calendarId);
      if (calendar) dispatch(saveCalendarSelected({ calendar, doctorId }));
    }
  }, [availability]);

  return (
    <Box>
      <AddressTitle variant="body1B">Local disponível nesta data e horário</AddressTitle>
      {physicalAppointments.map(calendar => (
        <AddressRoot
          key={calendar.id}
          className={!availability[calendar.id] ? 'disabled' : ''}
          onClick={() => {
            if (availability[calendar.id]) {
              dispatch(saveCalendarSelected({ calendar, doctorId }));
            }
          }}
        >
          <AddressIconBox>
            <AddressIcon />
          </AddressIconBox>
          <AddressContent>
            <Typography variant="body1B" sx={{ mt: 2, mb: 1 }}>
              {calendar.alias}
            </Typography>
            <Typography variant="body2R">{calendar.inviteFisicalAddress}</Typography>
          </AddressContent>
          <AddressRadio
            disabled={!availability[calendar.id]}
            checked={calendarSelected && calendarSelected.id === calendar.id ? true : false}
          />
        </AddressRoot>
      ))}
    </Box>
  );
};

export default Addresses;
